// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useI18n } from "@/i18n"

/**
 * Marks a price/savings/time figure as an estimate, per AGENTS.md: never
 * present estimated values as confirmed fact. Feature screens (T12/T13)
 * attach this to every non-authoritative number.
 */
export function EstimatedBadge({ className }: { className?: string }) {
  const { t } = useI18n()
  return (
    <span
      className={`inline-flex items-center rounded-bb-full bg-gold/20 px-2 py-0.5 text-xs font-medium text-ink-2 ${className ?? ""}`}
    >
      {t("state.estimated")}
    </span>
  )
}
